import { combineReducers } from 'redux';

import app from './app';
import events from './events';
import location from './location';
import search from './search';
import tara from './tara';

const reducers = combineReducers({
  app,
  events,
  location,
  search,
  tara,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js